import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {LexiboxImage} from '../../_models';
import {LexiboxService} from '../../_services';
import {first} from 'rxjs/operators';
import * as EXIF from 'exif-js';
import {getCurrentAbeille} from '../../../assets/utils.js';
import {NgxPicaErrorInterface, NgxPicaResizeOptionsInterface, NgxPicaService} from 'ngx-pica';

@Component({
  selector: 'app-create-lexibox',
  templateUrl: './create-lexibox.component.html',
  styleUrls: ['./create-lexibox.component.scss']
})
export class CreateLexiboxComponent implements OnInit {
    @ViewChild('fileField', {static: false}) fileField: ElementRef;
    @Output() refreshEvent = new EventEmitter<string>();

    patientId = '';
    imageSrc: string;
    imageOrientation = 1;
    uploading = false;
    file: File;
    fileThumbnail: File;
    errors = [];

    constructor(private lexiboxService: LexiboxService, private ngxPicaService: NgxPicaService) {
        this.patientId = getCurrentAbeille().id;
    }

    ngOnInit() {
    }

    clickFileInput(): void {
        this.fileField.nativeElement.click();
    }

    setNewPicture(event: Event): void {
        if ((event.target as HTMLInputElement).files && (event.target as HTMLInputElement).files[0]) {
            const file = (event.target as HTMLInputElement).files[0];

            this.ngxPicaService.resizeImage(file, 1200, 1200, {aspectRatio: {keepAspectRatio: true}})
                .subscribe((imageResized: File) => {
                    this.file = imageResized;

                }, (err: NgxPicaErrorInterface) => {
                    throw err.err;
            });


            this.ngxPicaService.resizeImage(file, 350, 350, {aspectRatio: {keepAspectRatio: true}})
                .subscribe((imageResized: File) => {
                    let reader: FileReader = new FileReader();

                    reader.addEventListener('load', (event: any) => {
                        this.imageSrc = 'url(' + (reader.result  as string) + ')';
                    }, false);

                    reader.readAsDataURL(imageResized);

                    this.fileThumbnail = imageResized;

                }, (err: NgxPicaErrorInterface) => {
                    throw err.err;
                });

            // Getting EXIF data to get orientation
            const fileReader = new FileReader();
            fileReader.addEventListener('load', fileReaderEvent => {
                const data = EXIF.readFromBinaryFile(fileReader.result);
                if (data && data.Orientation) {
                    //this.imageOrientation = data.Orientation;
                }
            });
            fileReader.readAsArrayBuffer(file);

        }
    }

    onClickSubmit(formData) {

        this.errors = [];
        let isOK = true;

        if (!formData.name) {
          this.errors[`name`] = true;
          isOK = false;
        }
        if (!this.file) {
          this.errors[`file`] = true;
          isOK = false;
        }

        if (!isOK) {
          return;
        }

        this.uploading = true;

        const image = new LexiboxImage({});
        image.name = formData.name;

        this.lexiboxService.registerByPatientId(this.patientId, image).pipe(first()).subscribe(image => {

            const imageId = (image as LexiboxImage).id.toString();
            this.lexiboxService.uploadFile( this.file ).pipe(first()).subscribe(picture => {
                const pictureId = picture['result']['files']['stoveImage'][0]['name'];

                this.lexiboxService.uploadFile( this.fileThumbnail ).pipe(first()).subscribe(thumbnail => {
                    const thumbnailId = thumbnail['result']['files']['stoveImage'][0]['name'];

                    this.lexiboxService.assignPicture(this.patientId, imageId, pictureId, thumbnailId ).pipe(first()).subscribe(image => {
                        this.file = null;
                        this.imageSrc = null;
                        this.refreshEvent.next();

                        this.uploading = false;
                    });
                });
            });
        });
    }

}
